import { useTranslation } from '@/hooks/use-translation';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/login/onboarding')({
  component: RouteComponent,
});

function RouteComponent() {
  const { t } = useTranslation('desktop_ui');

  return <div>{t('components.onboarding.message')}</div>;
}
